import {
  getApiV1ThreeLetterCodePartnerAdminsClientsClientId,
  getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsClientsClientId200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  /** 3文字コード */
  threeLetterCode: string;
  /** クライアントID */
  clientId: number;
};

type ReturnType = {
  /** クライアントデータ */
  data: GetApiV1ThreeLetterCodePartnerAdminsClientsClientId200;
};

/**
 * useGetPartnerAdminsClientフックの型定義
 */
type IUseGetPartnerAdminsClient = (args: Args) => ReturnType;

/**
 * パートナー管理者用クライアント詳細取得フック
 */
export const useGetPartnerAdminsClient: IUseGetPartnerAdminsClient = ({
  threeLetterCode,
  clientId,
}) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdKey(threeLetterCode, String(clientId)),
    () => getApiV1ThreeLetterCodePartnerAdminsClientsClientId(threeLetterCode, String(clientId)),
    { suspense: true }
  );

  return {
    data,
  };
};
